import { useMutation } from "urql";

import { DeleteLimitRequestConditionPrecedentDocument } from "../../../graphql/generated.ts";

export const useDeleteLimitRequestConditionPrecedent = () =>
  useMutation(DeleteLimitRequestConditionPrecedentDocument);
